export const UNPIN_POST_REQUEST = 'post/UNPIN_REQUEST';
export const UNPIN_POST_SUCCESS = 'post/UNPIN_SUCCESS';
export const UNPIN_POST_FAILURE = 'post/UNPIN_FAILURE';

export function unpinPost(id) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: UNPIN_POST_REQUEST,
    });

    const promise = request.post(`/_api/posts/${id}/unpin`);

    return promise
      .then(post =>
        dispatch({
          type: UNPIN_POST_SUCCESS,
          payload: post,
        })
      )
      .catch(() =>
        dispatch({
          type: UNPIN_POST_FAILURE,
        })
      )
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/unpin-post.js